Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = void 0;
var createStyles_1 = require("./createStyles");
Object.defineProperty(exports, "createStyles", { enumerable: true, get: function () { return createStyles_1.createStyles; } });
exports.default = createStyles_1.createStyles;
//# sourceMappingURL=index.js.map